import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
)

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const publicUrl = process.env.PUBLIC_URL || ''
    navigator.serviceWorker.register(`${publicUrl}/sw.js`).catch(() => {
      // ignore registration errors
    })
  })
}
